import { ContractMessage as ContractMessageResponse } from "../../api/HomePageResponseTypes";
import { Classifier } from "../../util/classifierManager";
import { DateString } from "../../util/conversionUtils";

export interface ContractMessage
  extends Omit<ContractMessageResponse, "lepinguLiik" | "lepinguAlamliik" | "saatmiseAeg"> {
  lepinguLiik: Classifier;
  lepinguAlamliik: Classifier;
  saatmiseAeg: DateString;
}

export enum ColumnHeader {
  contractNr = "contractNr",
  contractType = "contractType",
  contractSubtype = "contractSubtype",
  message = "message",
  sent = "sent",
}
